import { render, staticRenderFns } from "./phone.vue?vue&type=template&id=59901d80&"
import script from "./phone.vue?vue&type=script&lang=js&"
export * from "./phone.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/contactum-new/contactum-new/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('59901d80')) {
      api.createRecord('59901d80', component.options)
    } else {
      api.reload('59901d80', component.options)
    }
    module.hot.accept("./phone.vue?vue&type=template&id=59901d80&", function () {
      api.rerender('59901d80', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/admin/components/pro/form-template/phone.vue"
export default component.exports